import React from 'react';
import MenuButton from 'Common/MenuButton/MenuButton';
import MenuPage from 'Common/Navigation/MenuPage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';

const Menu = ({ onChange }) => {
    return (
        <MenuPage title="Appointee Management">
            <MenuButton
                title="Appointee Contract Response Data"
                icon={() => <FontAwesomeIcon icon={faFileSignature} size="9x" />}
                width="80%"
                onClick={() => onChange('appointee_contract_response')}
            />
        </MenuPage>
    );
};

export default Menu;
